import { client } from '../config/sanityClient';
import { Schema } from '../typings/sanityTypes';
import { Category } from './categoriesQuery';

export interface Branch {
  name: string;
  description?: string;
  category: Category;
}
export interface Marker {
  address: string;
  location: {
    lat: number;
    lng: number;
  };
  branches: Branch[];
}

const type: Schema = 'location';

export const getMarkers = async () => {
  const query = `*[_type == "${type}"]{
    branches[]->{
      name,
      description,
      category->{
        value,
        'color': color.hex,
        'id': _id
      },
    },
    location,
    address
  }`;
  const locations: Marker[] = await client.fetch(query);

  return locations;
};
